import React, { memo, Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ENTER_KEY, SPACE_KEYCODE, ARROW_DOWN_KEY, ARROW_UP_KEY, TAB_KEYCODE } from '../../Utils/constant';
import styles from '@dtsl/css-simple-select/dist/index.module.css';
import { Text } from '@dtsl/react/dist/components/Text';
const SimpleSelectOption = props => {
  const {
    option = {},
    onSelect = () => {},
    setIsMenuOpen,
    selectedValue = {},
    menuRef,
    focusedIndex,
    setFocusedIndex,
    children,
    triggerRef
  } = props;
  const {
    label,
    id,
    value,
    disabled,
    icon
  } = option;
  const handleOptionClick = e => {
    e.preventDefault();
    setIsMenuOpen(isMenuOpen => !isMenuOpen);
    onSelect(e, option);
    triggerRef?.current?.children[0]?.focus(); // Focus on trigger after selecting an option
  };
  let isSelected = label === selectedValue?.label;
  const optionClasses = classNames({
    [styles['sib-simple-select__option']]: true,
    [styles['sib-simple-select__option--selected']]: isSelected && !selectedValue?.disabled,
    [styles['sib-simple-select__option--disabled']]: disabled
  });
  // Function to set the focus on item
  function setFocus(index) {
    const items = menuRef?.current?.querySelector('ul')?.children;
    if (focusedIndex >= 0 && focusedIndex < items.length) {
      items[focusedIndex].removeAttribute('tabIndex');
    }
    setFocusedIndex(index);
    if (index >= 0 && index < items.length) {
      items[index].setAttribute('tabIndex', '0');
      items[index].focus();
    }
  }

  // Function to move focus based on direction
  function moveFocus(direction, options) {
    let newIndex = focusedIndex + direction;
    if (newIndex < 0) {
      newIndex = options.length - 1; // Loop to the end of the list
    } else if (newIndex >= options.length) {
      newIndex = 0; // Loop to the beginning of the list
    }
    while (options[newIndex].props.option.disabled) {
      newIndex += direction;
      if (newIndex < 0) {
        newIndex = options.length - 1; // Loop to the end of the list
      } else if (newIndex >= options.length) {
        newIndex = 0; // Loop to the beginning of the list
      }
    }
    setFocus(newIndex);
  }
  // Function to handle keydown event
  function handleKeyDown(e, disabled) {
    if ((e.key === ENTER_KEY || e.keyCode === SPACE_KEYCODE) && !disabled) {
      e.preventDefault();
      setIsMenuOpen(isMenuOpen => !isMenuOpen);
      onSelect(e, option);
      triggerRef?.current?.children[0]?.focus(); // Focus on trigger after selecting an option
    }
    if (e.key === ARROW_DOWN_KEY || e.key === ARROW_UP_KEY) {
      e.preventDefault(); // Prevent default scrolling behavior
      moveFocus(e.key === ARROW_UP_KEY ? -1 : 1, children);
    }
    if (e.keyCode === TAB_KEYCODE) {
      if (!e.shiftKey) {
        setIsMenuOpen(isMenuOpen => !isMenuOpen);
      }
    }
  }
  return /*#__PURE__*/React.createElement("li", {
    key: id || label || value,
    role: 'option',
    className: optionClasses,
    onClick: handleOptionClick,
    onKeyDown: handleKeyDown,
    "aria-disabled": disabled,
    "aria-selected": isSelected,
    title: label
  }, icon ? /*#__PURE__*/React.createElement("span", {
    className: styles['sib-simple-select__icon']
  }, icon()) : null, /*#__PURE__*/React.createElement(Text, {
    fontFamily: isSelected ? 'bold' : 'regular',
    color: "var(--sib-color_primary-default)",
    className: styles['sib-simple-select__label']
  }, label));
};
export default /*#__PURE__*/memo(SimpleSelectOption);
SimpleSelectOption.propTypes = {
  option: PropTypes.object,
  onSelect: PropTypes.func,
  setIsMenuOpen: PropTypes.func,
  selectedValue: PropTypes.object,
  menuRef: PropTypes.oneOfType([PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  }), PropTypes.shape({
    current: PropTypes.instanceOf(Component)
  })]),
  focusedIndex: PropTypes.number,
  setFocusedIndex: PropTypes.func,
  children: PropTypes.array,
  triggerRef: PropTypes.oneOfType([PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  }), PropTypes.shape({
    current: PropTypes.instanceOf(Component)
  })])
};